/* eslint-disable stylistic/quote-props */
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from "react";

import { Text as BaseText } from "@radix-ui/themes";

import { semanticColor as semanticColorMapper } from "../styles";
import { type PttProps, ptt } from "../util.props-to-tailwind";

type TextProps = {
  semanticColor?: keyof typeof semanticColorMapper;
} & ComponentPropsWithoutRef<typeof BaseText>
& Pick<PttProps, "leading" | "lineClamp">;
type TextRef = ElementRef<typeof BaseText>;

const Text = forwardRef<
  TextRef,
  TextProps
>((props, ref) => {
  const {
    className,
    color,
    leading,
    lineClamp,
    semanticColor,
    ...textProps
  } = props;

  return (
    <BaseText
      {...textProps}
      className={ptt({
        className,
        leading,
        lineClamp,
      })}
      color={(semanticColor && semanticColorMapper[semanticColor]) || color}
      ref={ref}
    />
  );
});
Text.displayName = BaseText.displayName;

export { Text, type TextProps };
